import instance from "../config/axios";
import { base_apis } from "../config/url";

export const checkEmail = (data) => {
    return instance.post(`${base_apis.account}/check-email`, data)
        .then((res) => {
            return res;
        });
};

export const validateEmailOtp = (data) => {
    return instance.post(`${base_apis.account}/validate-email`, data)
        .then((res) => {
            return res;
        });
};

export const applyReward = (data) => {
    return instance.post(`${base_apis.account}/apply-reward`, data)
        .then((res) => {
            return res;
        });
};

export const alreadyfavouriteGame = () => {
    return instance.post(`${base_apis.account}/getFavGames`)
        .then((res) => {
            return res;
        });
};
export const updatefavouriteGame = (data) => {
    return instance.post(`${base_apis.account}/update-favourite-games`,data)
        .then((res) => {
            return res;
        });
};